import axios from "axios";
import apiMixins from "@/mixins/apiMixins";
import postMixins from "@/mixins/postMixins";

export default {
    data() {
        return {
            token: '',
            siteId: ''
        };
    },
    mixins: [apiMixins, postMixins],
    created() {
        this.token = this.$session.get("jwt");
        if (this.siteId == '') this.siteId = this.$session.get("siteId");
    },
    methods: {
        async saveCategories(populate) {
            var totalData = { categories: this.categories };
            let token = this.$session.get("jwt");
            let siteId = this.$session.get("siteId");
            await axios({
                method: "post",
                url: process.env.ROOT_API +
                    "/api/site/" +
                    siteId +
                    "/category/update",
                data: totalData,
                headers: {
                    Authorization: "Bearer " + token,
                },
            }).then((response) => {
                if (populate == true) {
                    this.newSession = "";
                    this.categories = response.data.content;
                    this.$store.dispatch("dashboardModule/ADD_SECTIONS", [
                        this.categories[this.categories.length - 1],
                    ]);
                    setTimeout(() => {
                        let lastSection = this.categories[this.categories.length - 1];
                        if (lastSection.listPages == 1) {
                            window.localStorage.setItem(
                                "activeCategory",
                                lastSection.id
                            );
                            this.$router.go()
                        } else if (lastSection.type == "external_url") {
                            this.$session.set("pageId", lastSection.id);
                            this.$router.push("/dashboard/link-management");
                        } else if (lastSection.type == "store") {
                            this.$session.set("pageId", lastSection.id);
                            this.$router.push("/dashboard/store-management");
                        } else if (lastSection.renderTools == 1) {
                            this.$session.set("postId", lastSection.id);
                            this.$router.push({
                                name: "oldEditor",
                            });
                            this.$router.push({
                                name: "PostEditor",
                                params: { postId: lastSection.id },
                            });
                            this.$router.go()
                        } else {
                            this.$session.set("postId", lastSection.id);
                            this.$router.push({
                                name: "PostEditor",
                                params: { postId: lastSection.id },
                            });
                        }
                        this.$emit("updateDashboardActiveCategory");
                    }, 100);
                }
            });
        },
        applySiteScripts() {
            this.errorScript = "";
            this.updatingScripts = true;
            let header = this.siteHeaderScript;
            let footer = this.siteFooterScript;
            let token = this.$session.get("jwt");
            let siteId = this.$session.get("siteId");
            let formData = new FormData();
            formData.append("siteHeaderScript", header);
            formData.append("siteFooterScript", footer);
            axios({
                    method: "post",
                    url: process.env.ROOT_API +
                        "/api/site/" +
                        siteId +
                        "/script/update",
                    data: formData,
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    //handle success
                    this.updatingScripts = false;
                })
                .catch((response) => {
                    this.errorScript = "Erro ao atualizar scripts.";
                    this.updatingScripts = false;
                });
        },
        populateScripts() {
            let token = this.$session.get("jwt");
            let siteId = this.$session.get("siteId");
            axios({
                method: "get",
                url: process.env.ROOT_API + "/api/site/" + siteId + "/script",
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                //handle success
                if (response.data.status == 1) {
                    if (response.data.headerScript) {
                        this.siteHeaderScript = response.data.headerScript;
                    }
                    if (response.data.footerScript) {
                        this.siteFooterScript = response.data.footerScript;
                    }
                }
            });
        },
        handleRemoveCategory() {
            this.editSectionModal = false;
            this.alertRemoveCategory = true;
        },
        async removeCategory(category, option = 0) {
            let idActive = window.localStorage.getItem("activeCategory");

            if (category.id == idActive) {
                window.localStorage.removeItem("activeCategory");
            }
            if (category.id) {
                var totalData = "";
                let token = this.$session.get("jwt");
                let siteId = this.$session.get("siteId");
                await axios({
                        method: "post",
                        url: `${process.env.ROOT_API}/api/site/${siteId}/category/${category.id}/${option}/delete`,
                        data: totalData,
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        //handle success
                        if (response.data.status == 1) {
                            this.populateCategories();
                            this.editSectionModal = false;
                            this.elementIndex = "";
                            this.editableElement = {};
                        } else {
                            alert("Erro ao excluir categoria");
                        }
                        this.$emit("updateDashboardActiveCategory");
                    })
                    .catch(function(response) {
                        //handle error
                        alert("Erro ao remover página");
                        this.$refs["confirm-remove-page"].hide();
                        this.editSectionModal = false;
                        this.elementIndex = "";
                        this.editableElement = {};
                    });
            } else {
                this.populateCategories();
                this.$refs["confirm-remove-page"].hide();
                this.editSectionModal = false;
                this.elementIndex = "";
                this.editableElement = {};
                this.alertRemoveCategory = false;
            }
        },
        async handleUpdate() {
            if (!this.editableElement.name) {
                this.errorMessage = "Nome obrigatório";
            } else {
                await this.updateSection();
            }
        },
        async updateSection() {
            this.errorMessage = "";
            let totalData = this.editableElement;
            totalData.mainImage.url = this.activeMainImage;
            let token = this.$session.get("jwt");
            let siteId = this.$session.get("siteId");
            if (
                this.checkDuplicateCategory(
                    this.editableElement.name,
                    this.editableElement.id
                )
            ) {
                this.errorMessage = "Já existe uma página com esse nome.";
            } else {
                const res = await axios({
                    method: "post",
                    url: `${process.env.ROOT_API}/api/site/${siteId}/category/${this.editableElement.id}/update`,
                    data: totalData,
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                });
                                
                if (res.data.status === '1') {
                    this.editSectionModal = false;
                    this.resetEditModal();
                    this.$emit("updateDashboardActiveCategory");
                } else {
                    this.editSectionModal = false;
                    this.resetEditModal();
                }

            }
        },
        resetEditModal() {
            let item = this.categories.findIndex(
                (category) => category.id == this.backupSection.id
            );
            this.categories[item] = this.backupSection;
            this.editableElement = {};
            this.elementIndex = "";
            this.activeMainImage = "";
            this.mainImagePost = [];
            this.showSlides = false;
            this.uploadedPictures = [];
        },
        editSection(element, index) {
            this.isHomePage = element.isHome;
            this.editableElement = element;
            this.activeMainImage = element.mainImage.url;
            this.setMainImagePost();
            this.elementIndex = index;
            this.editSectionModal = true;
            this.backupSection = element;
            if (this.activeMainImage) {
                this.uploadedPictures.push({
                    mainImage: this.activeMainImage,
                });
            }
            setTimeout(() => {
                this.showSlides = true;
            }, 400);
        },
        populateCategories() {
            this.categories = [];
            let totalData = "";
            let token = this.$session.get("jwt");
            let siteId = this.$session.get("siteId");
            axios({
                    method: "get",
                    url: process.env.ROOT_API + "/api/site/" + siteId + "/section",
                    data: totalData,
                    headers: {
                        Authorization: "Bearer " + token,
                        // 'Content-Type': 'application/x-www-form-urlencoded'
                    },
                })
                .then((response) => {
                    this.categories = response.data.content;
                    this.categories = JSON.parse(JSON.stringify(this.categories))
                })
                .catch((response) => {
                    this.msgLoading = "Erro ao recuperar categorias";
                });
        },
        /* Verifica se tá tentando criar uma sessao valida */
        verifySection(sectionType) {
            if (sectionType) {
                return true
            }
            this.errorMessage = "Escolha o tipo."
            return false
        },
        verifyErrors() {
            let errors = true;
            this.errorMessage = "";
            if (!this.newSession) {
                this.errorMessage = "Nome da página obrigatório.";
            } else if (this.checkDuplicateCategory(this.newSession, null)) {
                this.errorMessage = "Já existe uma página com esse nome.";
            } else {
                if (this.newSession.length < 2) {
                    this.errorMessage = "Nome da página muito curto";
                } else {
                    errors = false
                }
            }
            return errors
        },
        /*
        Função que cria uma nova secao.
        Pode ser criada:
            - No menu Páginas
            - No meio de um post
            - No final de um post pela barra fixa

        Se for no menu páginas, deve redirecionar para a edicao da pagina
        Se for no meio de um post ou pela barra fixa, deve dar scroll até o post
        */
        async handleNewSection(sectionType, index = "", options = {}, organism = null) {
            if (this.section) {
                //cria nova pagina avulsa
                let errors = this.verifyErrors()

                if (errors) {
                    return false
                }

                this.loading = true;

                this.categories.push({
                    name: this.newSession,
                    target: this.newSessionTarget,
                    id: null,
                    visible: 1,
                    type: sectionType,
                    options: options,
                    combination: organism
                });
                this.newSessionTarget = 0;

                await this.saveCategories(true);

                return true;
            } else if (this.verifySection(sectionType)) {
                let data = { type: sectionType, combination: organism };

                this.loading = true;

                if (index) {
                    data.index = index;
                }

                const url = `/site/${this.siteId}/post/${this.postId}/card`;
                const responseApi = await this.requestApiData(url, "post", data);
                if (responseApi.status == 1) {
                    const update = await this.refreshPostEditorData(this.siteId, this.postId)

                    return responseApi
                    //this.$router.go()
                } else {
                    this.loading = false;
                    alert("Ocorreu um erro.");
                    return false
                }
            } else return false

            return false;
        },
        /* faz o scroll depois de atualizar o post */
        scrollToSection(id) {
            setTimeout(() => {
                var element_to_scroll_to = document.querySelector(`[id^="${id}"]`);
                if (element_to_scroll_to) {
                    element_to_scroll_to.scrollIntoView();
                }
            }, 100);
        },
        checkDuplicateCategory(newSession, sessionId) {
            let duplicate = false;
            newSession = newSession.trim();
            if (sessionId) {
                this.categories.forEach((element) => {
                    if (element.name == newSession && element.id != sessionId) {
                        duplicate = true;
                    }
                });
            } else {
                this.categories.forEach((element) => {
                    if (element.name == newSession) {
                        duplicate = true;
                    }
                });
            }
            return duplicate;
        }
    },
}



// WEBPACK FOOTER //
// ./src/mixins/sectionsMixins.js